import { Component, OnInit } from '@angular/core';
import { CustomerService } from '../../core/services/customer.service';
import { DefaultPageSize } from '../../core/dto/defaultPage.size';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { AppUtils } from '../../core/config/app.utils';
import { Pagination } from '../../core/dto/pagination';
import { LoadingService } from '../../core/services/loading.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import { SETTINGS } from '../../core/config/common.settings';
import { TranslocoService } from '@ngneat/transloco';

interface Customers {
  name: string;
  createdAt: any;
}

@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.scss'],
})
export class CustomersComponent implements OnInit {
  pageSize = new DefaultPageSize();
  sortField: any;
  sortOrder: any;

  allCustomers: any;
  customerSearch = '';

  sortColumn = {
    compareDate: (a: Customers, b: Customers) => {
      return (new Date(a.createdAt) as any) - (new Date(b.createdAt) as any);
    },
    compareName: (a: Customers, b: Customers) => a.name.localeCompare(b.name),
  };

  constructor(
    private customerService: CustomerService,
    private loading: LoadingService,
    private modal: NzModalService,
    private message: NzMessageService,
    private transloco: TranslocoService
  ) {}

  ngOnInit(): void {}
  getCustomers(): void {
    this.loading.start();
    const payload = Object.assign({}, new Pagination(this.pageSize), {
      sortField: this.sortField,
      sortOrder: this.sortOrder,
      keyword: this.customerSearch,
    });

    this.customerService.getAllCustomers(payload).then(res => {
      this.allCustomers = res.data;
      this.pageSize.length = res.metadata[0]?.total;
      this.loading.stop();
    });
  }

  onTableParamsChange(params: NzTableQueryParams): void {
    this.pageSize.pageSize = params.pageSize;
    this.pageSize.pageIndex = params.pageIndex;

    const currentSort = params.sort.find(item => item.value !== null);
    this.sortField = (currentSort && currentSort.key) || null;
    this.sortOrder =
      (currentSort && AppUtils.getSortOrder(currentSort.value)) || null;
    this.getCustomers();
  }

  search(): void {
    this.getCustomers();
  }

  reset(): void {
    this.customerSearch = '';
    this.getCustomers();
  }

  showDeleteCustomerModal(
    id: string,
    itinerariesCount: number,
    customerName: string
  ): void {
    const t = (key: string) => this.transloco.translate(key);
    if (itinerariesCount > 0) {
      const noun = itinerariesCount === 1
        ? t('customers.messages.itinerary')
        : t('customers.messages.itineraries');
      this.message.create('error', `${t('customers.messages.deletionNotPossible')} ${itinerariesCount} ${noun}.`);
    } else {
      this.modal.confirm({
        nzTitle: t('customers.deleteModal.title'),
        nzContent: `${t('customers.deleteModal.content')} ${customerName}?`,
        nzOkText: t('customers.deleteModal.ok'),
        nzOkType: 'primary',
        nzOkDanger: true,
        nzOnOk: () => this.deleteCustomer(id),
        nzCancelText: t('customers.deleteModal.cancel'),
      });
    }
  }

  deleteCustomer(id: string): void {
    this.loading.start();
    this.customerService.deleteCustomer(id).then(() => {
      this.message.success(this.transloco.translate('customers.messages.deleted'));
      this.getCustomers();
    });
  }

  protected readonly SETTINGS = SETTINGS;
}
